import { SortBy } from './product-search.model';
import { Category } from './category.model';
import { VariantGrouping, ProductVariance, RelatedProduct, SimilarProduct } from './product-variance.model';

export interface ProductDetails {
  productId: number;
  description: string;
  name: string;
  brandName: string;
  brandId: number;
  price: number;
  priceEquivOriginal: number;
  discountedPrice: number;
  category: Category;
  isPromo: boolean;
  imageUrl: string;
  images: Array<string[]>;
  isTruckShip: boolean;
  isOutOfStock?: boolean;
  pointConversionRate?: number;
  features?: Array<{
    text: string;
    order: number;
  }>;
  specifications?: Array<{
    text: string;
    order: number;
  }>;
  estimatedShippingDays: string;
}

export interface ProductDetailsDto extends Omit<ProductDetails, 'images'> {
  images: Array<{ sourceSet: string[] }>;
}

export const mapProductDetailsDtoToInternal = (model: ProductDetailsDto): ProductDetails => {
  return {
    ...model,
    images: (model?.images ?? []).map((imgeObject) => imgeObject.sourceSet),
  };
};

export const PRODUCT_LIST_SORTING_OPTIONS: { label: string; value: SortBy; ariaLabel: string }[] = [
  { label: 'Recommended', value: SortBy.Recommended, ariaLabel: 'Sort by recommended' },
  { label: 'Prices (Low - high)', value: SortBy.Price, ariaLabel: 'Sort by Prices from low to high' },
  { label: 'Prices (High - low)', value: SortBy.PriceDesc, ariaLabel: 'Sort by Prices from high to low' },
  { label: 'New arrivals', value: SortBy.NewArrival, ariaLabel: 'Sort by new arrival' },
];

export const FAILED_LOADING_PRODUCT_ITEM: ProductDetailsDto = { productId: 0 } as ProductDetailsDto;
export const isFailedProductsResponse = (products: ProductDetails[]): boolean =>
  products[0]?.productId === FAILED_LOADING_PRODUCT_ITEM.productId;

export interface ProductLegacy {
  CatID?: string;
  ProductID?: string;
  Mileage?: string;
  BrandID?: number;
  Name?: string;
  NameAccessible?: string;
  ProductManAndTitle?: string;
  Description?: string;
  NameEsp?: string;
  DescriptionEsp?: string;
  RestrictedShipping?: string;
  clientRedemptionOrderItemId: string;
  redemptionOrderItemCashAmount?: string;
  imageName?: string;
  featured?: string;
  videoName?: string;
  relatedFlag?: string;
  smallImage1?: string;
  smallImage2?: string;
  colorFlag?: string;
  collectionFlag?: string;
  hexColor?: string;
  qty?: number;
  href?: string;
  carttype?: string;
  shipping?: string;
  ItemNumber?: string;

  OldMileage?: string;
  reviewCount?: number;
  reviewRating?: number;
  primaryFlag?: string;
  cartCount: number;
  Prop65?: string;
  subtotal?: number;
  productReviews?: [
    {
      RatingID?: string;
      ProductID?: string;
      Active?: boolean;
      CreatedDate?: Date;
      CreatedBy?: string;
      FromDatabase?: string;
      Rating?: string;
    },
  ];
  addedToWishlist?: boolean;
  MileageOriginal: string;
  PriceEquiv: string;
  PriceEquivOriginal: string;
  isPromo: string;
}
export interface ProductDetailsWithVariant extends ProductDetails {
  productId: number;
  brandId: number;
  name: string;
  brandName: string;
  partNumber: string;
  description: string;
  price: number;
  discountedPrice: number;
  isPromo: boolean;
  isTruckShip: boolean;
  isActive: boolean;
  isOutOfStock: boolean;
  imageUrl: string;
  category: Category;
  images: Array<string[]>;
  pointConversionRate?: number;
  features?: Array<{
    text: string;
    order: number;
  }>;
  specifications?: Array<{
    header: string;
    text: string;
    order: number;
    headerDisplayOrder: number;
  }>;
  productVariances: ProductVariance[];
  variantGroupings: VariantGrouping[];
  relatedProducts: RelatedProduct[];
  similarProducts: SimilarProduct[];
}
export const isDiscontedPrice = (product: ProductDetails) => Boolean(product.discountedPrice);
